export default "__VITE_ASSET__DhPMcRsw__"